import { connect } from 'react-redux';

import StepFour from '../../components/StepFour/StepFour';

// const mapStateToProps = state => {
//   const {
//     selectedFirst,
//     selectedSecond,
//   } = state.stepOne;
//
//   const {
//     currentService,
//   } = state.stepTwo;
//
//   return {
//
//   };
// }

export default connect(null, null)(StepFour);
// export default connect(mapStateToProps, null)(StepFour);
